import React, {useEffect, useRef, useState} from 'react';
import {
  createSubCategory, deactivateRiskSubCategory,
  deleteSubCategory,
  getAllCategories,
  getAllCategoriesActive, updateSubCategory,
} from '../../../services/riskSubCategoriesServices';
import {getLanguage, t} from 'react-switch-lang';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import Swal from 'sweetalert2';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from '../Metodologies/plus.png';
import CustomTable from '../../../components/customTable/CustomTable';

const RiskSubCategories = () => {
  const [query, setQuery] = useState();
  const addButton = useRef();
  const [activeCategories, setActiveCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [{ data: active }, { data: all }] = await Promise.all([
          getAllCategoriesActive(),
          getAllCategories(),
        ]);

        setActiveCategories(active);
        setAllCategories(all);
      } catch (err) {}
    };

    fetchData();
  }, []);
  const formatedCategories = activeCategories?.map((d) => ({
    label: getLanguage() === 'eng' ? d?.nameEn : d?.name,
    value: d?.id,
  }));
  const allCategoriesOptions = allCategories?.map((d) => ({
    label: getLanguage() === 'eng' ? d?.nameEn : d?.name,
    value: d?.id,
    active: d?.active,
  }));

  const columns = [
    {
      dataIndex: 'name',
      title: t('riskCategories.name'),
      editable: true,
      placeholder: t('riskCategories.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('riskCategories.nameEn'),
      editable: true,
      placeholder: t('riskCategories.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'riskCategoryId',
      nestedKey: getLanguage() === 'eng' ? 'nameEn' : 'name',
      title: t('riskSubCategories.riskCategory'),
      editable: false,
      inputType: 'customSelect',
      options: formatedCategories,
      render: (value) => {
        const category = allCategoriesOptions?.find((d) => d?.value === value);
        return category?.label;
      },
      rules: [{required: true, message: t('message.fieldRequired')}],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.id = editingRecord.id;
    data.active = editingRecord.active
    data.riskCategoryId = editingRecord?.riskCategoryId
    try {
      const response = await updateSubCategory(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('riskSubCategories.message.updateSuccess', {
            entity: t('riskSubCategories.riskSubCategory'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('riskSubCategories.subcategoryExists')],
          },
        ]);
      } else if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('riskSubCategories.subcategoryExists')],
          },
        ]);
      }
    }
  };

  return (
    <div className="subCategories administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search">
          <SearchBox
            placeholder={t('riskSubCategories.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
      </div>
      <CustomTable
        api="/risk-subcategories"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate}}
        addButtonRef={addButton}
        actionsWidth={100}
        deactivateButton={true}
        hideDeleteAndDeactivation={true}
      />
    </div>
  );
};

export default RiskSubCategories;